"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[31474],{

/***/ 28868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Packs_PackPriceFormat; }
});

// UNUSED EXPORTS: useStyles

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
// EXTERNAL MODULE: ./components/Packs/PacksCard.tsx
var PacksCard = __webpack_require__(69036);
;// CONCATENATED MODULE: ./components/Shop/PackPrice.tsx






var PackPrice = function(param) {
    var data = param.data, amount = param.amount, _showDayOrMonth = param.showDayOrMonth, showDayOrMonth = _showDayOrMonth === void 0 ? true : _showDayOrMonth;
    var classes = (0,PacksCard/* useStyles */.y)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: 'h3',
        className: (0,clsx_m/* default */.Z)('pack__price', classes.whiteSpace),
        component: 'span',
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
            amount: amount,
            showDayOrMonth: showDayOrMonth,
            isShort: false,
            dayOrMonth: data === null || data === void 0 ? void 0 : data.day_or_month,
            dayOrMonthShort: data === null || data === void 0 ? void 0 : data.day_or_month_short,
            displayFlexPrice: data === null || data === void 0 ? void 0 : data.display_flex_price_a_day
        })
    }));
};
/* harmony default export */ var Shop_PackPrice = (PackPrice);

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./components/Packs/PackPriceFormat.tsx






var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        oldPrice: {
            textDecoration: 'line-through'
        },
        marginLeft: {
            marginLeft: theme.spacing(1)
        },
        promotion: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            borderRadius: theme.spacing(0.5),
            fontSize: '75%',
            marginLeft: theme.spacing(1),
            padding: theme.spacing(0, 0.5)
        }
    });
});
var PackPriceFormat = function(param) {
    var promotions = param.promotions, settings = param.settings, productPrice = param.minPrice, discountPriceFormat = param.discountPriceFormat, _isDisplayPercentage = param.isDisplayPercentage, isDisplayPercentage = _isDisplayPercentage === void 0 ? false : _isDisplayPercentage;
    var classes = useStyles();
    var currentPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.currentPromotion;
    var isPerMonth = settings === null || settings === void 0 ? void 0 : settings.show_price_per_month;
    var minPrice = productPrice * (isPerMonth ? 30 : 1);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !constants/* isClassicSub */.q5 && !currentPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_PackPrice, {
                data: settings,
                amount: minPrice
            }),
            !constants/* isClassicSub */.q5 && currentPromotion !== null && currentPromotion && discountPriceFormat === constants/* PRICE_WITHOUT_DISCOUNT */.HB && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_PackPrice, {
                data: settings,
                amount: minPrice
            }),
            !constants/* isClassicSub */.q5 && currentPromotion !== null && currentPromotion && discountPriceFormat === constants/* DISCOUNTED_PRICE_ONLY */.Qn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_PackPrice, {
                data: settings,
                amount: minPrice - minPrice * currentPromotion / 100
            }),
            !constants/* isClassicSub */.q5 && currentPromotion !== null && currentPromotion && discountPriceFormat === constants/* DISCOUNTED_PRICE_WITH_DETAILS */.B8 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pack__amount",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)('pack__oldPrice', classes.oldPrice),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_PackPrice, {
                            data: settings,
                            amount: minPrice,
                            showDayOrMonth: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classes.marginLeft,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_PackPrice, {
                            data: settings,
                            amount: minPrice - minPrice * currentPromotion / 100
                        })
                    }),
                    isDisplayPercentage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (0,clsx_m/* default */.Z)('pack__discount', classes.promotion),
                        children: [
                            "-",
                            currentPromotion,
                            "\xa0%"
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Packs_PackPriceFormat = (PackPriceFormat);


/***/ }),

/***/ 69036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useStyles; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(55953);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(56251);
/* harmony import */ var _Link_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31520);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36456);
/* harmony import */ var react_glider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76142);
/* harmony import */ var react_glider__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_glider__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(86700);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16502);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41107);
/* harmony import */ var _Sizes_SizeModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26035);
/* harmony import */ var _Shop_ProductCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18496);
/* harmony import */ var _ImgKitHandler_ImgKitHandler__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26137);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94455);
/* harmony import */ var _utils_usePackAvailability__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20030);
/* harmony import */ var _PackPriceFormat__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28868);
/* harmony import */ var _redux_actions_packs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37876);
/* harmony import */ var _hooks_useCart__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(19789);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(66026);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11163);






















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
        row: _defineProperty({
            display: 'flex',
            margin: theme.spacing(0, 0, 2)
        }, theme.breakpoints.up('lg'), {
            margin: 0
        }),
        // Common Pack Style
        packAvailability: {
            display: 'inline-block',
            marginBottom: theme.spacing(2),
            padding: theme.spacing(0.5, 1),
            borderRadius: theme.spacing(2),
            background: theme.palette.common.black,
            color: theme.palette.common.white
        },
        packTitleLayout: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: theme.spacing(0.5)
        },
        packContent: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        packCarousel: {
            '& .glider-prev': {
                left: 0
            },
            '& .glider-next': {
                right: 0
            },
            '& .glider-contain': _defineProperty({
                paddingLeft: 32,
                paddingRight: 32
            }, theme.breakpoints.up('md'), {
                paddingLeft: 40,
                paddingRight: 40
            })
        },
        packCarouselSlide: {
            margin: theme.spacing(0, 1)
        },
        packCarouselMedia: {},
        packTop: {
            position: 'relative'
        },
        packTopLink: {
            color: theme.palette.common.black,
            '&:before': {
                zIndex: 1,
                content: "''",
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        },
        packBottom: {},
        packDesc: (_obj = {
            margin: theme.spacing(1, 0),
            color: theme.extraColors.greyText,
            lineHeight: 1.4
        }, _defineProperty(_obj, theme.breakpoints.down('lg'), {
            fontSize: theme.typography.pxToRem(12)
        }), _defineProperty(_obj, theme.breakpoints.up('lg'), {
            minHeight: 40
        }), _defineProperty(_obj, theme.breakpoints.up('xl'), {
            minHeight: 76
        }), _obj),
        // Pack Sport Specific Style
        packSport: {},
        packSportHead: {
            position: 'relative',
            zIndex: 2,
            padding: theme.spacing(3, 2),
            boxShadow: theme.shadows[1],
            borderTop: "3px solid ".concat(theme.palette.primary.main),
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.common.white
        },
        packSportContent: {
            paddingLeft: theme.spacing(2)
        },
        packSportBottom: {},
        packSportFoot: {
            position: 'relative',
            textAlign: 'center',
            zIndex: 1,
            marginTop: -20,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(4, 2, 2, 2),
            boxShadow: theme.shadows[1],
            backgroundColor: theme.extraColors.greyLight,
            overflow: 'hidden',
            display: 'flex',
            gap: theme.spacing(1),
            justifyContent: 'center'
        },
        packSportTitle: _defineProperty({
            display: 'flex',
            flexDirection: 'column'
        }, theme.breakpoints.up('md'), {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
        }),
        // Pack Fashion Specific Style
        packFashion: {
            overflow: 'hidden',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.common.white,
            boxShadow: theme.shadows[1],
            '& .glider-contain': {
                '& .glider-next, & .glider-prev': {
                    opacity: 0
                },
                '&:hover, &:focus': {
                    '& .glider-next, & .glider-prev': {
                        opacity: 1,
                        '&[aria-disabled=true]': {
                            opacity: 0.3
                        }
                    }
                }
            }
        },
        packFashionContent: _defineProperty({
            padding: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            padding: theme.spacing(5, 3)
        }),
        packFashionTitle: {},
        packBottomFashion: {
            display: 'flex',
            gap: theme.spacing(1),
            flexDirection: 'column',
            alignItems: 'flex-start'
        },
        // Fake Pack Specific Style
        fakePack: {
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.common.white,
            boxShadow: theme.shadows[1]
        },
        fakePackContent: _defineProperty({
            position: 'relative',
            zIndex: 2,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(3, 2),
            boxShadow: theme.shadows[1],
            background: theme.palette.primaryTransparent.light
        }, theme.breakpoints.up('sm'), {
            minHeight: '282px'
        }),
        fakePackHead: _defineProperty({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: theme.spacing(2),
            padding: theme.spacing(0, 2)
        }, theme.breakpoints.down('sm'), {
            textAlign: 'center',
            display: 'block'
        }),
        fakePackFoot: {
            padding: theme.spacing(2, 0, 0),
            textAlign: 'center'
        },
        // Partner Push inside Pack List
        push: _defineProperty({
            overflow: 'hidden',
            borderRadius: theme.shape.borderRadius,
            position: 'relative',
            boxShadow: theme.shadows[1]
        }, theme.breakpoints.up('md'), {
            minHeight: '100%'
        }),
        pushImg: _defineProperty({
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }, theme.breakpoints.up('md'), {
            position: 'absolute',
            zIndex: 1,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }),
        pushContent: {
            position: 'absolute',
            zIndex: 2,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            rowGap: theme.spacing(2),
            padding: theme.spacing(3),
            background: 'rgba(0, 0, 0, .25)'
        },
        pushTitle: {
            textAlign: 'center',
            color: theme.palette.common.white
        },
        whiteSpace: {
            whiteSpace: 'nowrap'
        }
    });
});
var PacksCard = function(param1) {
    var index = param1.index, pack = param1.pack, cart = param1.cart, settings = param1.settings, stock = param1.stock, text = param1.text, thumbRatio = param1.thumbRatio, thumbWidth = param1.thumbWidth, cardWidth = param1.cardWidth, packLayout = param1.packLayout, promotions = param1.promotions, t = param1.t, numberPack = param1.numberPack, latestProducts = param1.latestProducts, packPush = param1.packPush, takeback = param1.takeback, takeBackLP = param1.takeBackLP, savePackOrigin1 = param1.savePackOrigin;
    var ref18, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var addMultipleProductToCart = (0,_hooks_useCart__WEBPACK_IMPORTED_MODULE_15__/* .useCart */ .j)().addMultipleProductToCart;
    var classes = useStyles();
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)();
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), openModal = ref15[0], setOpenModal = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), minPrice1 = ref16[0], setMinPrice = ref16[1];
    var trackEvent = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)().trackEvent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_17__.useRouter)();
    var packState = (0,_utils_usePackAvailability__WEBPACK_IMPORTED_MODULE_12__/* .usePackAvailability */ .J)(settings === null || settings === void 0 ? void 0 : settings.add_pack_if_complete, pack === null || pack === void 0 ? void 0 : pack.packProducts, stock);
    var isMobile = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(theme.breakpoints.down('sm'));
    var isHtmlDescription = text === null || text === void 0 ? void 0 : text.is_html_description;
    var preventAddingToCart = settings === null || settings === void 0 ? void 0 : settings.prevent_adding_to_cart_without_details;
    var discountPriceFormat = settings === null || settings === void 0 ? void 0 : settings.discounted_price_display_format;
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), selection1 = ref17[0], setSelection = ref17[1];
    var category = router === null || router === void 0 ? void 0 : (ref18 = router.query) === null || ref18 === void 0 ? void 0 : ref18.slug;
    var isSecondHandTaxon = _utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .isSecondHandOnly */ .G7 === 'true' ? true : _utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .SECOND_HAND_TAXON_SLUGS.includes */ .$X.includes(category === null || category === void 0 ? void 0 : category[0]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var minPrice = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .calcPackMinPrice */ .hQ)(pack === null || pack === void 0 ? void 0 : pack.packProducts);
        setMinPrice(minPrice);
    }, [
        promotions === null || promotions === void 0 ? void 0 : promotions.currentPromotion
    ]);
    // add pack with all variants
    var AddMultipleProductsToCart = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(selection) {
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        // add selection to cart
                        trackEvent({
                            category: 'Packs',
                            action: "Add products from packs in Cart"
                        });
                        _ctx.next = 3;
                        return addMultipleProductToCart({
                            items: selection
                        });
                    case 3:
                        setSelection([]);
                        setOpenModal(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function AddMultipleProductsToCart(selection) {
            return _ref.apply(this, arguments);
        };
    }();
    var setOpenModalAndTrack = function() {
        setOpenModal(true);
        trackEvent({
            category: 'Packs',
            action: "Open Pack ".concat(pack.code, " modale")
        });
    };
    var goToPackAndTrack = function() {
        trackEvent({
            category: 'Packs',
            action: "Go to Pack: ".concat(pack.slug)
        });
        savePackOrigin1('packs');
    };
    var PackCarousel = function(param) {
        var _isBig = param.isBig, isBig = _isBig === void 0 ? false : _isBig;
        var ref19;
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)('pack__carousel', classes.packCarousel),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((react_glider__WEBPACK_IMPORTED_MODULE_5___default()), {
                hasArrows: true,
                draggable: true,
                scrollLock: true,
                slidesToShow: 4,
                iconLeft: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {}),
                iconRight: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {}),
                children: pack === null || pack === void 0 ? void 0 : (ref19 = pack.packProducts) === null || ref19 === void 0 ? void 0 : ref19.map(function(product) {
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: classes.packCarouselSlide,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            "data-ratio": thumbRatio,
                            className: classes.packCarouselMedia,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImgKitHandler_ImgKitHandler__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                imagePaths: (ref = product.product) === null || ref === void 0 ? void 0 : ref.images[0],
                                settings: {
                                    quality: 75,
                                    width: isBig ? cardWidth : thumbWidth,
                                    ar: thumbRatio === null || thumbRatio === void 0 ? void 0 : thumbRatio.substring(3)
                                }
                            })
                        })
                    }, "packCarouselSlide-".concat(product.product.code));
                })
            })
        }));
    };
    var PackTitle = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)('packCard-title__layout', classes.packTitleLayout),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                    variant: "h3",
                    component: "h2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        href: "./packs/".concat(pack.slug),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)('packCard-title__link', classes.packTopLink),
                            children: pack.name
                        })
                    })
                }),
                packState.soldOut && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)('packCard-title__availability', classes.packAvailability, "packCard-title__availability__".concat(pack === null || pack === void 0 ? void 0 : pack.code)),
                    variant: "caption",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        asText: true,
                        data: text === null || text === void 0 ? void 0 : text.sold_out,
                        defaultText: t('texts:packs:victim_of_success')
                    })
                })
            ]
        });
    };
    var PackDesc = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
            variant: "body1",
            component: "div",
            className: "pack__desc ".concat(classes.packDesc),
            children: pack.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncateString */ .aS)(pack.description, (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(theme.breakpoints.up('lg')) ? 250 : 100, isHtmlDescription)
                }
            })
        });
    };
    var PackActions = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                (settings === null || settings === void 0 ? void 0 : settings.add_a_pack_from_pack_page) && !packState.soldOut && !preventAddingToCart && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    size: isMobile ? 'small' : 'medium',
                    variant: "contained",
                    color: 'secondary',
                    onClick: function() {
                        return setOpenModalAndTrack();
                    },
                    className: 'pack__cta',
                    "data-testid": "select-pack-".concat(pack.id),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        asText: true,
                        data: text === null || text === void 0 ? void 0 : text.select,
                        defaultText: t('texts:packs:select')
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: "./packs/".concat(pack.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        onClick: function() {
                            return goToPackAndTrack();
                        },
                        className: 'pack__a-link',
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            size: isMobile ? 'small' : 'medium',
                            component: "span",
                            variant: "contained",
                            color: 'primary',
                            className: 'pack__link',
                            "data-testid": "go-to-pack-".concat(pack.id),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                asText: true,
                                data: text === null || text === void 0 ? void 0 : text.link_to_single,
                                defaultText: t('texts:packs:link_to_single')
                            })
                        })
                    })
                })
            ]
        });
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            packPush && packPush.length > 0 && index === packPush[0].list_position - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                item: true,
                xs: 12,
                lg: 6,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "pack-push ".concat(classes.push),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        href: ((ref1 = packPush[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta_link) === null || ref2 === void 0 ? void 0 : ref2.url) ? (ref3 = packPush[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.cta_link) === null || ref4 === void 0 ? void 0 : ref4.url : '/',
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                            target: ((ref5 = packPush[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.cta_link) === null || ref6 === void 0 ? void 0 : ref6.target) ? '_blank' : '_self',
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "pack-push__content ".concat(classes.pushContent),
                                    children: [
                                        (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* .isPrismicText */ .LT)((ref7 = packPush[0]) === null || ref7 === void 0 ? void 0 : ref7.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                            variant: 'h2',
                                            className: "pack-push__title ".concat(classes.pushTitle),
                                            children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* .prismicText */ .yz)((ref8 = packPush[0]) === null || ref8 === void 0 ? void 0 : ref8.title)
                                        }),
                                        (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* .isPrismicText */ .LT)((ref9 = packPush[0]) === null || ref9 === void 0 ? void 0 : ref9.cta_label) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            variant: 'contained',
                                            color: 'primary',
                                            className: 'pack-push__btn',
                                            children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* .prismicText */ .yz)((ref10 = packPush[0]) === null || ref10 === void 0 ? void 0 : ref10.cta_label)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    src: (ref11 = packPush[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.image) === null || ref12 === void 0 ? void 0 : ref12.url,
                                    alt: '',
                                    className: classes.pushImg
                                })
                            ]
                        })
                    })
                })
            }, "pack-push"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                item: true,
                xs: 12,
                lg: 6,
                children: [
                    packLayout === 'Sport' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("article", {
                        className: "packSport ".concat(classes.packSport),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "packSport__head ".concat(classes.packSportHead),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                        container: true,
                                        spacing: 0,
                                        className: classes.row,
                                        children: [
                                            pack.images.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                xs: 4,
                                                item: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    href: "./packs/".concat(pack.slug),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            "data-ratio": thumbRatio,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImgKitHandler_ImgKitHandler__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                imagePaths: pack.images[0],
                                                                alt: '',
                                                                settings: {
                                                                    quality: 75,
                                                                    width: cardWidth,
                                                                    ar: thumbRatio === null || thumbRatio === void 0 ? void 0 : thumbRatio.substring(3)
                                                                }
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                xs: pack.images.length > 0 ? 8 : 12,
                                                item: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "".concat(classes.packContent, " ").concat(classes.packSportContent),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: classes.packTop,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                    className: "pack__title ".concat(classes.packSportTitle),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackTitle, {}),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                            className: "packCard-title__price__".concat(pack === null || pack === void 0 ? void 0 : pack.code),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PackPriceFormat__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                                promotions: promotions,
                                                                                settings: settings,
                                                                                minPrice: minPrice1,
                                                                                discountPriceFormat: discountPriceFormat
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackDesc, {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: classes.packBottom,
                                                            children: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(theme.breakpoints.up('md')) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackCarousel, {})
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackCarousel, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)('packSport__foot', classes.packSportFoot),
                                "data-stockloaded": (stock === null || stock === void 0 ? void 0 : stock.loading) ? 'loading' : 'loaded',
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackActions, {})
                            })
                        ]
                    }),
                    packLayout === 'Sport Full' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("article", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)('packSport', 'packSport--full', classes.packSport),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)('packSport__head', classes.packSportHead),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                    container: true,
                                    spacing: 0,
                                    className: classes.row,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                        xs: 12,
                                        item: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "".concat(classes.packContent),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: classes.packTop,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: "pack__title ".concat(classes.packSportTitle),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackTitle, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PackPriceFormat__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                        promotions: promotions,
                                                                        settings: settings,
                                                                        minPrice: minPrice1,
                                                                        discountPriceFormat: discountPriceFormat
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackDesc, {})
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: classes.packSportBottom,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackCarousel, {})
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)('packSport__foot', classes.packSportFoot),
                                "data-stockloaded": (stock === null || stock === void 0 ? void 0 : stock.loading) ? 'loading' : 'loaded',
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackActions, {})
                            })
                        ]
                    }),
                    packLayout === 'Fashion' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("article", {
                        className: "packFashion ".concat(classes.packFashion),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                            container: true,
                            spacing: 0,
                            className: classes.row,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                    xs: 12,
                                    md: 6,
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((react_glider__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        hasArrows: true,
                                        draggable: true,
                                        scrollLock: true,
                                        slidesToShow: 1,
                                        iconLeft: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {}),
                                        iconRight: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {}),
                                        children: [
                                            pack.images.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    "data-ratio": thumbRatio,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImgKitHandler_ImgKitHandler__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                        imagePaths: pack.images[0],
                                                        alt: '',
                                                        settings: {
                                                            quality: 75,
                                                            width: cardWidth,
                                                            ar: thumbRatio === null || thumbRatio === void 0 ? void 0 : thumbRatio.substring(3)
                                                        }
                                                    })
                                                })
                                            }),
                                            pack === null || pack === void 0 ? void 0 : (ref13 = pack.packProducts) === null || ref13 === void 0 ? void 0 : ref13.map(function(product) {
                                                var ref, ref20;
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        "data-ratio": thumbRatio,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImgKitHandler_ImgKitHandler__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            imagePaths: product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.images[0],
                                                            alt: '',
                                                            settings: {
                                                                quality: 75,
                                                                width: cardWidth,
                                                                ar: thumbRatio === null || thumbRatio === void 0 ? void 0 : thumbRatio.substring(3)
                                                            }
                                                        })
                                                    })
                                                }, "packCarouselSlide-".concat(product === null || product === void 0 ? void 0 : (ref20 = product.product) === null || ref20 === void 0 ? void 0 : ref20.code));
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                    xs: 12,
                                    md: 6,
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "pack__fashionContent ".concat(classes.packContent, " ").concat(classes.packFashionContent),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: classes.packTop,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "pack__title ".concat(classes.packFashionTitle),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackTitle, {}),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PackPriceFormat__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                promotions: promotions,
                                                                settings: settings,
                                                                minPrice: minPrice1,
                                                                discountPriceFormat: discountPriceFormat
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackDesc, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(classes.packBottom, classes.packBottomFashion, 'pack__bottomFashion'),
                                                "data-stockloaded": (stock === null || stock === void 0 ? void 0 : stock.loading) ? 'loading' : 'loaded',
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PackActions, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }, "pack-".concat(pack.id)),
            index === numberPack - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                item: true,
                xs: 12,
                lg: 6,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("article", {
                    className: classes.fakePack,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classes.fakePackContent,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: classes.fakePackHead,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                        variant: 'h3',
                                        color: 'primary',
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                            asText: true,
                                            data: text === null || text === void 0 ? void 0 : (ref14 = text.fake_pack_title) === null || ref14 === void 0 ? void 0 : ref14.text,
                                            defaultText: t('texts:packs:fake_pack_title')
                                        })
                                    }),
                                    (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(theme.breakpoints.up('sm')) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        href: "/shop",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                variant: 'outlined',
                                                color: 'primary',
                                                size: 'small',
                                                onClick: function() {
                                                    return trackEvent({
                                                        category: 'Packs',
                                                        href: "/shop",
                                                        action: "Fake pack to shop"
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                    asText: true,
                                                    data: text === null || text === void 0 ? void 0 : text.fake_pack_button,
                                                    defaultText: t('texts:packs:fake_pack_button')
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            (latestProducts === null || latestProducts === void 0 ? void 0 : latestProducts.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: classes.packCarousel,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((react_glider__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    hasArrows: true,
                                    draggable: true,
                                    scrollLock: true,
                                    slidesToShow: 4,
                                    iconLeft: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {}),
                                    iconRight: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {}),
                                    children: latestProducts === null || latestProducts === void 0 ? void 0 : latestProducts.map(function(product) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: classes.packCarouselSlide,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Shop_ProductCard__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                name: product.name,
                                                text: text,
                                                thumb: product === null || product === void 0 ? void 0 : product.images[0],
                                                thumbRatio: thumbRatio,
                                                thumbWidth: cardWidth,
                                                productCode: product.code,
                                                product: product,
                                                small: true,
                                                slug: product.slug,
                                                addButton: false,
                                                settings: settings
                                            })
                                        }, "packCarouselSlide-".concat(product.code));
                                    })
                                })
                            }),
                            isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: classes.fakePackFoot,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    href: "/shop",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            size: 'small',
                                            variant: 'outlined',
                                            color: 'primary',
                                            onClick: function() {
                                                return trackEvent({
                                                    category: 'Packs',
                                                    href: "/shop",
                                                    action: "mobile fake pack to shop"
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                asText: true,
                                                data: text === null || text === void 0 ? void 0 : text.fake_pack_button,
                                                defaultText: t('texts:packs:fake_pack_button')
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }, "pack-fake"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Sizes_SizeModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                open: openModal,
                handleClose: function() {
                    return setOpenModal(false);
                },
                type: 'pack',
                text: text,
                stock: stock,
                products: pack.packProducts,
                cart: cart,
                AddMultipleProductsToCart: AddMultipleProductsToCart,
                thumbRatio: thumbRatio,
                thumbWidth: thumbWidth,
                isMobile: isMobile,
                settings: settings,
                selection: selection1,
                setSelection: setSelection,
                isSecondHandTaxon: isSecondHandTaxon,
                takeback: takeback,
                takeBackLP: takeBackLP
            })
        ]
    }));
};
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        stock: state.stock,
        promotions: state.promotions,
        takeBackLP: state.takeBack
    };
};
var mapDispatchToProps = {
    savePackOrigin: _redux_actions_packs__WEBPACK_IMPORTED_MODULE_14__/* .savePackOrigin */ .Dq
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(PacksCard));


/***/ }),

/***/ 37876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NX": function() { return /* binding */ deletePackOrigin; },
  "Ht": function() { return /* binding */ getPackTaxons; },
  "M9": function() { return /* binding */ packs_getPacksByPackTaxonId; },
  "VH": function() { return /* binding */ saveCurrentPack; },
  "Dq": function() { return /* binding */ savePackOrigin; }
});

// UNUSED EXPORTS: ACTIONS, DELETE_PACK_ORIGIN, GET_PACKS_BY_PACK_TAXON_ID_FAILURE, GET_PACKS_BY_PACK_TAXON_ID_REQUEST, GET_PACKS_BY_PACK_TAXON_ID_SUCCESS, GET_PACKS_TAXONS_FAILURE, GET_PACKS_TAXONS_REQUEST, GET_PACKS_TAXONS_SUCCESS, SAVE_CURRENT_PACK, SAVE_PACK_ORIGIN

// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/packs.ts


var getPacksTaxons = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.taxonPack */.KU.taxonPack
    });
};
var getPacksByPackTaxonId = function(id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.packs */.KU.packs,
        uid: "".concat(id)
    });
};

;// CONCATENATED MODULE: ./redux/actions/packs.ts

var ACTIONS = {
    GET_PACKS_TAXONS_REQUEST: 'GET_PACKS_TAXONS_REQUEST',
    GET_PACKS_TAXONS_SUCCESS: 'GET_PACKS_TAXONS_SUCCESS',
    GET_PACKS_TAXONS_FAILURE: 'GET_PACKS_TAXONS_FAILURE',
    GET_PACKS_BY_PACK_TAXON_ID_REQUEST: 'GET_PACKS_BY_PACK_TAXON_ID_REQUEST',
    GET_PACKS_BY_PACK_TAXON_ID_SUCCESS: 'GET_PACKS_BY_PACK_TAXON_ID_SUCCESS',
    GET_PACKS_BY_PACK_TAXON_ID_FAILURE: 'GET_PACKS_BY_PACK_TAXON_ID_FAILURE',
    SAVE_CURRENT_PACK: 'SAVE_CURRENT_PACK',
    SAVE_PACK_ORIGIN: 'SAVE_PACK_ORIGIN',
    DELETE_PACK_ORIGIN: 'DELETE_PACK_ORIGIN'
};
var GET_PACKS_TAXONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PACKS_TAXONS_REQUEST
    };
};
var GET_PACKS_TAXONS_SUCCESS = function(taxonPack) {
    return {
        type: ACTIONS.GET_PACKS_TAXONS_SUCCESS,
        taxonPack: taxonPack
    };
};
var GET_PACKS_TAXONS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PACKS_TAXONS_FAILURE,
        err: err
    };
};
function getPackTaxons() {
    return function(dispatch) {
        dispatch(GET_PACKS_TAXONS_REQUEST());
        return getPacksTaxons().then(function(response) {
            return dispatch(GET_PACKS_TAXONS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PACKS_TAXONS_FAILURE(err));
        });
    };
}
var GET_PACKS_BY_PACK_TAXON_ID_REQUEST = function() {
    return {
        type: ACTIONS.GET_PACKS_BY_PACK_TAXON_ID_REQUEST
    };
};
var GET_PACKS_BY_PACK_TAXON_ID_SUCCESS = function(packs) {
    return {
        type: ACTIONS.GET_PACKS_BY_PACK_TAXON_ID_SUCCESS,
        packs: packs
    };
};
var GET_PACKS_BY_PACK_TAXON_ID_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PACKS_BY_PACK_TAXON_ID_FAILURE,
        err: err
    };
};
function packs_getPacksByPackTaxonId(id) {
    return function(dispatch) {
        dispatch(GET_PACKS_BY_PACK_TAXON_ID_REQUEST());
        return getPacksByPackTaxonId(id).then(function(response) {
            return dispatch(GET_PACKS_BY_PACK_TAXON_ID_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PACKS_BY_PACK_TAXON_ID_FAILURE(err));
        });
    };
}
var SAVE_CURRENT_PACK = function(currentPack) {
    return {
        type: ACTIONS.SAVE_CURRENT_PACK,
        currentPack: currentPack
    };
};
function saveCurrentPack(currentPack) {
    return function(dispatch) {
        dispatch(SAVE_CURRENT_PACK(currentPack));
    };
}
var SAVE_PACK_ORIGIN = function(origin) {
    return {
        type: ACTIONS.SAVE_PACK_ORIGIN,
        origin: origin
    };
};
function savePackOrigin(origin) {
    return function(dispatch) {
        dispatch(SAVE_PACK_ORIGIN(origin));
    };
}
var DELETE_PACK_ORIGIN = function() {
    return {
        type: ACTIONS.DELETE_PACK_ORIGIN
    };
};
function deletePackOrigin() {
    return function(dispatch) {
        dispatch(DELETE_PACK_ORIGIN());
    };
}


/***/ }),

/***/ 20030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ usePackAvailability; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16502);


var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var usePackAvailability = function(settings, packProducts, stock) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), soldOut = ref[0], setIsSoldOut = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (settings && (typeof packProducts === "undefined" ? "undefined" : _typeof(packProducts)) !== undefined && (packProducts === null || packProducts === void 0 ? void 0 : packProducts.length) > 0) {
            var packAvailability = [];
            packProducts === null || packProducts === void 0 ? void 0 : packProducts.forEach(function(packProduct) {
                var isAvailable = 'ko';
                isAvailable = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .checkProductAvailability */ .HF)(stock, packProduct.product).available ? 'ok' : 'ko';
                packAvailability.push(isAvailable);
            });
            setIsSoldOut(packAvailability.includes('ko'));
        }
    }, [
        packProducts,
        stock
    ]);
    return {
        soldOut: soldOut
    };
};


/***/ })

}]);